import React, { Component } from 'react';
import SelectField from '../../forms/SelectField';
import { TIMEZONE_OPTIONS } from '../../../lib/date.utils';

class TimezoneSelect extends Component {
    render() {
        return (
            <SelectField
                name="timeZone"
                onChange={this.props.onChange}
                label={this.props.label}
                value={this.props.value || ''}
                items={TIMEZONE_OPTIONS}
            />
        );
    }
}

export default TimezoneSelect;
